import { render } from "./chatPage.vue?vue&type=template&id=b6e59ea8"
import script from "./chatPage.vue?vue&type=script&lang=js"
export * from "./chatPage.vue?vue&type=script&lang=js"

import "./chatPage.vue?vue&type=style&index=0&id=b6e59ea8&lang=scss"
script.render = render

export default script